export const getters = {
  getAuthError(state) {
    return state.authError;
  }
}
